"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: user/user.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Fuser%2Fuser.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.userSsnOnFileToJSON = exports.userSsnOnFileFromJSON = exports.UserShipping = exports.User = exports.UserSsnOnFile = void 0;
const address_1 = require("../common/address");
const kyc_1 = require("../common/kyc");
const kyc_error_1 = require("../common/kyc-error");
const legal_name_1 = require("../common/legal-name");
const protobufPackage = 'com.step.user.proto';
var UserSsnOnFile;
(function (UserSsnOnFile) {
    UserSsnOnFile["INVALID_SSN_ON_FILE"] = "INVALID_SSN_ON_FILE";
    UserSsnOnFile["FULL"] = "FULL";
    UserSsnOnFile["LAST4"] = "LAST4";
    UserSsnOnFile["UNRECOGNIZED"] = "UNRECOGNIZED";
})(UserSsnOnFile || (exports.UserSsnOnFile = UserSsnOnFile = {}));
function createBaseUser() {
    return {
        id: '',
        nickname: '',
        dob: '',
        legalName: undefined,
        address: undefined,
        kycStatus: kyc_1.KycStatus.INVALID,
        kycErrors: [],
        pictureUrl: '',
        shipping: undefined,
        createdAtMs: '0',
        updatedAtMs: '0',
        ssnOnFile: UserSsnOnFile.INVALID_SSN_ON_FILE,
        autoBilling: false,
        reportCredit: false,
        monitorCredit: false,
    };
}
exports.User = {
    fromJSON(object) {
        const message = {
            id: isSet(object.id) ? globalThis.String(object.id) : '',
            autoBilling: isSet(object.autoBilling) ? globalThis.Boolean(object.autoBilling) : false,
        };
        if (isSet(object.nickname)) {
            message.nickname = globalThis.String(object.nickname);
        }
        if (isSet(object.dob)) {
            message.dob = globalThis.String(object.dob);
        }
        if (isSet(object.legalName)) {
            message.legalName = legal_name_1.LegalName.fromJSON(object.legalName);
        }
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        if (isSet(object.kycStatus)) {
            message.kycStatus = (0, kyc_1.kycStatusFromJSON)(object.kycStatus);
        }
        if (globalThis.Array.isArray(object?.kycErrors)) {
            message.kycErrors = object.kycErrors.map((e) => (0, kyc_error_1.kycErrorFromJSON)(e));
        }
        if (isSet(object.pictureUrl)) {
            message.pictureUrl = globalThis.String(object.pictureUrl);
        }
        if (isSet(object.shipping)) {
            message.shipping = exports.UserShipping.fromJSON(object.shipping);
        }
        if (isSet(object.createdAtMs)) {
            message.createdAtMs = globalThis.String(object.createdAtMs);
        }
        if (isSet(object.updatedAtMs)) {
            message.updatedAtMs = globalThis.String(object.updatedAtMs);
        }
        if (isSet(object.ssnOnFile)) {
            message.ssnOnFile = userSsnOnFileFromJSON(object.ssnOnFile);
        }
        if (isSet(object.reportCredit)) {
            message.reportCredit = globalThis.Boolean(object.reportCredit);
        }
        if (isSet(object.monitorCredit)) {
            message.monitorCredit = globalThis.Boolean(object.monitorCredit);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.id !== '') {
            obj.id = message.id;
        }
        if (message.nickname !== undefined && message.nickname !== '') {
            obj.nickname = message.nickname;
        }
        if (message.dob !== undefined && message.dob !== '') {
            obj.dob = message.dob;
        }
        if (message.legalName !== undefined) {
            obj.legalName = legal_name_1.LegalName.toJSON(message.legalName);
        }
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.kycStatus !== undefined && message.kycStatus !== kyc_1.KycStatus.INVALID) {
            obj.kycStatus = (0, kyc_1.kycStatusToJSON)(message.kycStatus);
        }
        if (message.kycErrors?.length) {
            obj.kycErrors = message.kycErrors.map((e) => (0, kyc_error_1.kycErrorToJSON)(e));
        }
        if (message.pictureUrl !== undefined && message.pictureUrl !== '') {
            obj.pictureUrl = message.pictureUrl;
        }
        if (message.shipping !== undefined) {
            obj.shipping = exports.UserShipping.toJSON(message.shipping);
        }
        if (message.createdAtMs !== undefined && message.createdAtMs !== '0') {
            obj.createdAtMs = message.createdAtMs;
        }
        if (message.updatedAtMs !== undefined && message.updatedAtMs !== '0') {
            obj.updatedAtMs = message.updatedAtMs;
        }
        if (message.ssnOnFile !== undefined && message.ssnOnFile !== UserSsnOnFile.INVALID_SSN_ON_FILE) {
            obj.ssnOnFile = userSsnOnFileToJSON(message.ssnOnFile);
        }
        if (message.autoBilling !== false) {
            obj.autoBilling = message.autoBilling;
        }
        if (message.reportCredit !== undefined && message.reportCredit !== false) {
            obj.reportCredit = message.reportCredit;
        }
        if (message.monitorCredit !== undefined && message.monitorCredit !== false) {
            obj.monitorCredit = message.monitorCredit;
        }
        return obj;
    },
    create(base) {
        return exports.User.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUser();
        message.id = object.id ?? '';
        message.nickname = object.nickname ?? '';
        message.dob = object.dob ?? '';
        message.legalName = (object.legalName !== undefined && object.legalName !== null)
            ? legal_name_1.LegalName.fromPartial(object.legalName)
            : undefined;
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        message.kycStatus = object.kycStatus ?? kyc_1.KycStatus.INVALID;
        message.kycErrors = object.kycErrors?.map((e) => e) || [];
        message.pictureUrl = object.pictureUrl ?? '';
        message.shipping = (object.shipping !== undefined && object.shipping !== null)
            ? exports.UserShipping.fromPartial(object.shipping)
            : undefined;
        message.createdAtMs = object.createdAtMs ?? '0';
        message.updatedAtMs = object.updatedAtMs ?? '0';
        message.ssnOnFile = object.ssnOnFile ?? UserSsnOnFile.INVALID_SSN_ON_FILE;
        message.autoBilling = object.autoBilling ?? false;
        message.reportCredit = object.reportCredit ?? false;
        message.monitorCredit = object.monitorCredit ?? false;
        return message;
    },
};
function createBaseUserShipping() {
    return { address: undefined, isConfirmed: false, isValidated: false };
}
exports.UserShipping = {
    fromJSON(object) {
        const message = {};
        if (isSet(object.address)) {
            message.address = address_1.Address.fromJSON(object.address);
        }
        if (isSet(object.isConfirmed)) {
            message.isConfirmed = globalThis.Boolean(object.isConfirmed);
        }
        if (isSet(object.isValidated)) {
            message.isValidated = globalThis.Boolean(object.isValidated);
        }
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.address !== undefined) {
            obj.address = address_1.Address.toJSON(message.address);
        }
        if (message.isConfirmed !== undefined && message.isConfirmed !== false) {
            obj.isConfirmed = message.isConfirmed;
        }
        if (message.isValidated !== undefined && message.isValidated !== false) {
            obj.isValidated = message.isValidated;
        }
        return obj;
    },
    create(base) {
        return exports.UserShipping.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseUserShipping();
        message.address = (object.address !== undefined && object.address !== null)
            ? address_1.Address.fromPartial(object.address)
            : undefined;
        message.isConfirmed = object.isConfirmed ?? false;
        message.isValidated = object.isValidated ?? false;
        return message;
    },
};
function userSsnOnFileFromJSON(object) {
    switch (object) {
        case 0:
        case 'INVALID_SSN_ON_FILE':
            return UserSsnOnFile.INVALID_SSN_ON_FILE;
        case 1:
        case 'FULL':
            return UserSsnOnFile.FULL;
        case 2:
        case 'LAST4':
            return UserSsnOnFile.LAST4;
        case -1:
        case 'UNRECOGNIZED':
        default:
            return UserSsnOnFile.UNRECOGNIZED;
    }
}
exports.userSsnOnFileFromJSON = userSsnOnFileFromJSON;
function userSsnOnFileToJSON(object) {
    switch (object) {
        case UserSsnOnFile.INVALID_SSN_ON_FILE:
            return 'INVALID_SSN_ON_FILE';
        case UserSsnOnFile.FULL:
            return 'FULL';
        case UserSsnOnFile.LAST4:
            return 'LAST4';
        case UserSsnOnFile.UNRECOGNIZED:
        default:
            return 'UNRECOGNIZED';
    }
}
exports.userSsnOnFileToJSON = userSsnOnFileToJSON;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=user.js.map